module.exports = __webpack_public_path__ + "static/img/img2.9e750220.png";